import { noop } from 'lodash-es';

import consoleApiSlice from './consoleApiSlice';

const userSlice = consoleApiSlice.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getUser: builder.query({
      query: () => '/v1/users/me/',
      providesTags: ['User'],
    }),
    register: builder.mutation({
      query: ({ firstName, lastName, idToken }) => ({
        url: '/v1/auth/register-with-firebase/',
        method: 'POST',
        body: { firstName, lastName, idToken },
      }),
      onQueryStarted: (args, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(() => {
            dispatch(userSlice.endpoints.getUser.initiate(undefined, { forceRefetch: true }));
          })
          .catch(noop);
      },
    }),
    login: builder.mutation({
      query: ({ idToken }) => ({ url: '/v1/auth/login-with-firebase/', method: 'POST', body: { idToken } }),
      onQueryStarted: (args, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(() => {
            dispatch(userSlice.endpoints.getUser.initiate(undefined, { forceRefetch: true }));
          })
          .catch(noop);
      },
    }),
    verifyEmail: builder.mutation({
      query: ({ email, token }) => ({ url: '/v1/auth/verify-email/', method: 'POST', body: { email, token } }),
      onQueryStarted: (args, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(() => {
            dispatch(userSlice.endpoints.getUser.initiate(undefined, { forceRefetch: true }));
          })
          .catch(noop);
      },
    }),
    logout: builder.mutation({
      query: () => ({ url: '/v1/auth/logout/', method: 'POST' }),
      onQueryStarted: (arg, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(() => {
            dispatch(consoleApiSlice.util.resetApiState());
          })
          .catch(noop);
      },
    }),
    createCompanyRep: builder.mutation({
      query: ({ role, customRole, countryIsoCode, phone }) => ({
        url: '/v1/users/me/create-company-rep/',
        method: 'POST',
        body: { role, customRole, countryIsoCode, phone },
      }),
      onQueryStarted: (args, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(() => {
            dispatch(userSlice.endpoints.getUser.initiate(undefined, { forceRefetch: true }));
          })
          .catch((resp) => {
            const errorCode = resp.error?.data?.errorCode;
            if (errorCode === 'COMPANY_REP_EXISTS') {
              dispatch(userSlice.endpoints.getUser.initiate(undefined, { forceRefetch: true }));
              return;
            }
          });
      },
    }),
    verifyUserDetails: builder.mutation({
      query: () => ({ url: '/v1/users/me/verify-details/', method: 'POST' }),
      invalidatesTags: ['User'],
    }),
  }),
});

// Exports
export default userSlice;
export const {
  useGetUserQuery,
  useGetUserOnboardingQuery,
  useRegisterMutation,
  useLoginMutation,
  useVerifyEmailMutation,
  useLogoutMutation,
  useCreateCompanyRepMutation,
  useVerifyUserDetailsMutation,
} = userSlice;
